import axios from 'axios'

import type {
	ReleasePreviewRequest,
	ReleasePreviewResponse,
} from '../../shared/types/preview'

export async function getReleasePreviews(
	releaseId: number,
	request: ReleasePreviewRequest,
): Promise<ReleasePreviewResponse> {
	const response = await axios.post(
		`/api/releases/${releaseId}/previews`,
		request,
		{ params: { country: getBrowserCountry() } },
	)
	return response.data as ReleasePreviewResponse
}

function getBrowserCountry(): string {
	const match = navigator.language.match(/[-_]([A-Za-z]{2})\b/)
	return match?.[1]?.toUpperCase() ?? 'US'
}
